import type { Template } from "@/types";

export const LA_03_H1_V2: Template[] = [
{
    id: "la-03-h1v2-01",
    name: "LA 01 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 79, y: 96, width: 479, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 705, y: 67, width: 247, height: 342, rotation: 0, imageRotation: 0 },
            { id: "3", x: 959, y: 67, width: 247, height: 342, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-02",
    name: "LA 02 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 68, y: 67, width: 247, height: 342, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 67, width: 247, height: 342, rotation: 0, imageRotation: 0 },
            { id: "3", x: 716, y: 96, width: 479, height: 284, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-03",
    name: "LA 03 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 50, y: 40, width: 288, height: 396, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 40, width: 584, height: 396, rotation: 0, imageRotation: 0 },
            { id: "3", x: 938, y: 40, width: 287, height: 396, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-04",
    name: "LA 04 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 50, y: 40, width: 288, height: 396, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 40, width: 287, height: 396, rotation: 0, imageRotation: 0 },
            { id: "3", x: 642, y: 40, width: 584, height: 396, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-05",
    name: "LA 05 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 36, y: 32, width: 564, height: 411, rotation: 0, imageRotation: 0 },
            { id: "2", x: 725, y: 96, width: 227, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 959, y: 96, width: 227, height: 307, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-06",
    name: "LA 06 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 62, y: 59, width: 512, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 758, y: 108, width: 195, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 960, y: 108, width: 194, height: 261, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-07",
    name: "LA 07 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 56, y: 61, width: 260, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 323, y: 61, width: 259, height: 355, rotation: 0, imageRotation: 0 },
            { id: "3", x: 702, y: 61, width: 508, height: 355, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-08",
    name: "LA 08 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 48, y: 32, width: 287, height: 411, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 32, width: 588, height: 411, rotation: 0, imageRotation: 0 },
            { id: "3", x: 939, y: 32, width: 287, height: 411, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-09",
    name: "LA 09 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 65, y: 100, width: 206, height: 275, rotation: 0, imageRotation: 0 },
            { id: "2", x: 279, y: 100, width: 206, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 554, y: 0, width: 720, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v2-10",
    name: "LA 10 - H1V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 123, y: 108, width: 192, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 323, y: 108, width: 191, height: 262, rotation: 0, imageRotation: 0 },
            { id: "3", x: 673, y: 39, width: 566, height: 401, rotation: 0, imageRotation: 0 }
    ],
}
];